import React, { useEffect, createElement } from 'react';
import { useScreenInit } from './useScreenInit';
import { Hero } from './components/Hero';
import { TestimonialsStrip } from './components/TestimonialsStrip';
import { PainPoints } from './components/PainPoints';
import { SolutionReveal } from './components/SolutionReveal';
import { ClassLibrary } from './components/ClassLibrary';
import { BonusSection } from './components/BonusSection';
import { PricingSection } from './components/PricingSection';
import { ExtendedTestimonials } from './components/ExtendedTestimonials';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchaseNotifications } from './components/PurchaseNotifications';
const META_PIXEL_ID = '2510816822713849';
type PixelFunction = {
  (...args: unknown[]): void;
  callMethod?: (...args: unknown[]) => void;
  queue?: unknown[][];
  push?: PixelFunction;
  loaded?: boolean;
  version?: string;
};
function useMetaPixel() {
  useEffect(() => {
    const pixelWindow = window as Window & {
      fbq?: PixelFunction;
      _fbq?: PixelFunction;
    };
    if (pixelWindow.fbq) {
      pixelWindow.fbq('track', 'PageView');
      return;
    }
    try {
      const fbq: PixelFunction = (...args) => {
        if (fbq.callMethod) {
          fbq.callMethod(...args);
          return;
        }
        fbq.queue?.push(args);
      };
      fbq.queue = [];
      fbq.push = fbq;
      fbq.loaded = true;
      fbq.version = '2.0';
      pixelWindow.fbq = fbq;
      pixelWindow._fbq = fbq;
      fbq('init', META_PIXEL_ID);
      fbq('track', 'PageView');
      const script = document.createElement('script');
      script.id = 'meta-pixel-script';
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      script.onerror = () => console.warn('Meta Pixel could not be loaded.');
      document.head.appendChild(script);
      return () => {
        script.onerror = null;
      };
    } catch (error) {
      console.warn('Meta Pixel initialization failed.', error);
    }
  }, []);
}
export function App() {
  useScreenInit();
  useMetaPixel();
  return <div className="min-h-screen w-full bg-charcoal text-white" data-id="element-0">
      <main data-id="element-1">
        <Hero data-id="element-2" />
        <TestimonialsStrip data-id="element-3" />
        <PainPoints data-id="element-4" />
        <SolutionReveal data-id="element-5" />
        <ClassLibrary data-id="element-6" />
        <BonusSection data-id="element-7" />
        <PricingSection data-id="element-8" />
        <ExtendedTestimonials data-id="element-9" />
        <Guarantee data-id="element-10" />
        <FAQ data-id="element-11" />
        <FinalCTA data-id="element-12" />
      </main>
      <Footer data-id="element-13" />
      <PurchaseNotifications data-id="element-14" />
    </div>;
}